import { GetStaticPaths, GetStaticProps } from 'next';
import { getLearningPath, getModule, getQuiz, getMetas, getUnit, getAssessment } from 'data/contentful-api';
import {
  getMetasPreview,
  getLearningPatPreview,
  getModulePreview,
  getUnitPreview,
  getQuizPreview,
  getAssessmentPreview,
} from '../contenful-api/getMetas';
import React from 'react';
import LearningPathPage from 'layouts/learning-path-page';
import ModulePage from 'layouts/module-page';
import UnitPage from 'layouts/unit-page';
import AssessmentPage from 'layouts/assessment-page';
// import { IS_PRODUCTION } from 'utils/constants';

type SlugPageProps = {
  type: string;
  data: LearningPath | Module | Unit | Meta | Assessment;
};

export const SlugPage: React.FC<SlugPageProps> = ({ type, data }) => {
  if (type === 'LearningPath') {
    return <LearningPathPage data={data as LearningPath} />;
  }
  if (type === 'Module') {
    return <ModulePage data={data as Module} />;
  }
  if (type === 'Unit') {
    return <UnitPage data={data as Unit} />;
  }
  if (type === 'Quiz') {
    return <UnitPage data={data as Unit} />;
  }
  if (type === 'Assessment') {
    return <AssessmentPage data={data as Assessment} />;
  }
  return (
    <div>
      <h1>Not found</h1>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
};

export const getStaticProps: GetStaticProps<SlugPageProps, { slug: string[] }> = async ({
  locale,
  params,
  preview,
  // previewData,
}) => {
  const path = `/${params.slug.join('/')}`;
  const metas = !preview ? await getMetas({ fresh: false }) : []; // Er lige blevet cached i preview kald
  const meta = metas.find((item) => item.path === path && item.locale === locale); //`/${locale}${path}`);
  const metasPreview = preview ? await getMetasPreview(preview) : [];
  const metaPreview = metasPreview.find((item) => item.path === path && item.locale === locale);

  if (!meta && !metaPreview) {
    return {
      notFound: true,
    };
  }

  let data: LearningPath | Module | Unit | Meta | null = null;

  if (preview) {
    if (metaPreview.type === 'LearningPath') {
      data = await getLearningPatPreview({
        locale: locale as AcceptedLocales,
        id: metaPreview.id,
        preview: true,
        useRawBody: false,
      });
    }
    if (metaPreview.type === 'Module') {
      data = await getModulePreview({
        locale: locale as AcceptedLocales,
        id: metaPreview.id,
        path,
        preview: true,
        useRawBody: false,
      });
    }
    if (metaPreview.type === 'Unit') {
      data = await getUnitPreview({
        locale: locale as AcceptedLocales,
        id: metaPreview.id,
        path,
        preview: true,
        useRawBody: false,
      });
    }
    if (metaPreview.type === 'Quiz') {
      data = await getQuizPreview({
        locale: locale as AcceptedLocales,
        id: metaPreview.id,
        path,
        preview: true,
        useRawBody: false,
      });
    }
    if (metaPreview.type === 'Assessment') {
      data = await getAssessmentPreview({
        locale: locale as AcceptedLocales,
        id: metaPreview.id,
        path,
        preview,
        useRawBody: false,
        withResults: false,
      });
    }
  }

  if (!preview && meta) {
    if (meta.type === 'LearningPath') {
      data = await getLearningPath({
        locale: locale as AcceptedLocales,
        id: meta.id,
        preview,
        useRawBody: false,
      });
    }
    if (meta.type === 'Module') {
      data = await getModule({ locale: locale as AcceptedLocales, id: meta.id, path, preview, useRawBody: false });
    }
    if (meta.type === 'Unit') {
      data = await getUnit({ locale: locale as AcceptedLocales, id: meta.id, path, preview, useRawBody: false });
    }
    if (meta.type === 'Quiz') {
      data = await getQuiz({ locale: locale as AcceptedLocales, id: meta.id, path, preview, useRawBody: false });
    }
    if (meta.type === 'Assessment') {
      data = await getAssessment({
        locale: locale as AcceptedLocales,
        id: meta.id,
        path,
        preview,
        useRawBody: false,
        withResults: false,
      });
    }
  }

  if (!data) {
    // console.log('@@ NO DATA', { meta, path, params });
    return {
      notFound: true,
    };
  }

  return {
    props: { type: preview ? metaPreview.type : meta.type, data },
    // revalidate: 1,
  };
};

type Params = { slug: string[] };

export const getStaticPaths: GetStaticPaths<Params> = async () => {
  // const metas = await getMetas({ fresh: false });

  // console.log('isProd', IS_PRODUCTION);

  // if (IS_PRODUCTION) {
  //   return {
  //     paths: metas.map((meta) => {
  //       return { params: { slug: meta.slug }, locale: meta.locale as AcceptedLocales };
  //     }),
  //     fallback: 'blocking',
  //   };
  // }

  return {
    paths: [],
    fallback: 'blocking',
  };
};

export default SlugPage;
